import React, { ChangeEvent, Component, useContext, useEffect, useState } from "react";
import "./ShopifySelectShopModal.scss";
import OwButton from "../OwButton/OwButton";
import IErrorDTO from "../../../models/DTO/IErrorDTO";
import ISupplierModel from "../../../models/ISupplierModel";
import OwTitle from "../OwTitle/OwTitle";
import IUserUI from "../../../models/IUserUI";
import SupplierContext from "../../../contexts/SupplierContext";
import OwSelectOption from "../OwSelectOption/OwSelectOption";
import OwCheckbox from "../OwCheckbox/OwCheckbox";
import IShopify from "../../../models/IShopify";
import OwLabel from "../OwLabel/OwLabel";

type Props = {
    closeModalFn: () => void;
    selectedShopFn: (allShops: boolean, shopGuid?: string) => void;
};

export const ShopifySelectShopModal: React.FC<Props> = (props) => {
    const supplierModel = useContext(SupplierContext);

    const [allShops, setAllShops] = useState(true);
    const [shopGuid, setShopGuid] = useState<string | undefined>();

    useEffect(() => {
        if (!allShops) {
            setShopGuid(undefined);
        }
    }, [allShops]);

    const closeModal = () => {
        props.closeModalFn();
    };

    const selectShop = () => {
        props.selectedShopFn(allShops, shopGuid);
    };

    const selectedShop = (shop: IShopify) => {
        setShopGuid(shop.guid);
    };

    const selectAllShops = (e: ChangeEvent<any>) => {
        const value = e.target.value;

        setAllShops(value);
    };

    return (
        <div className={"ShopifySelectShopModal p-2"}>
            <div className={"w-100"}>
                <div className={"d-flex justify-content-between"}>
                    <OwTitle leftIconName={"fad fa-store"} title={"shopify_shop"} tag={"h3"} />
                    <div>
                        <OwButton className={"btn-danger"} centerIconClass={"fas fa-times"} fn={closeModal} />
                    </div>
                </div>
            </div>

            <div>
                <div>
                    <OwSelectOption
                        name={"shop"}
                        fn={selectedShop}
                        options={supplierModel.Shopifies}
                        valueProp={"guid"}
                        titleProp={"shopify_shop"}
                        isDisabled={allShops}
                        selectedOption={shopGuid}
                        emitObject={true}
                    />
                </div>
            </div>

            <div className="mt-4">
                <OwButton title={"start"} fn={selectShop} disabled={!allShops && !shopGuid} />
            </div>
        </div>
    );
};
